import { useState } from "react";

import { SeletorEmpresaConciliacao } from "../conciliacao/SeletorEmpresaConciliacao";
import { FilaConciliacao } from "../conciliacao/FilaConciliacao";

/*
 * Página de conciliação bancária assistida (FE-3 CP-B — LEITURA).
 *
 * Estado local (client-state efêmero de tela): a empresa selecionada. Conciliação
 * é SEMPRE por empresa — não há escopo de grupo aqui (espelha a estrutura de
 * `Projecao.tsx`, mas sem o ramo consolidado).
 *
 * Renderiza o `SeletorEmpresaConciliacao` e, quando há empresa escolhida, a
 * `FilaConciliacao` da empresa (status "aberta"). A confirmação real (escrita) é
 * do CP-C — esta fatia é só leitura.
 */
export function Conciliacao(): JSX.Element {
  const [empresaId, setEmpresaId] = useState<string | null>(null);

  return (
    <section className="flex flex-col gap-6">
      <h1 className="font-titulo text-2xl text-off-black">Conciliação</h1>

      <SeletorEmpresaConciliacao
        selecionada={empresaId}
        aoSelecionar={setEmpresaId}
      />

      {empresaId === null ? (
        <p className="font-corpo text-base text-off-black">
          Selecione uma empresa para ver a fila de conciliação.
        </p>
      ) : (
        <FilaConciliacao empresaId={empresaId} />
      )}
    </section>
  );
}
